import { render, staticRenderFns } from "./ToggleSidebar.vue?vue&type=template&id=59080ec0&scoped=true"
import script from "./ToggleSidebar.vue?vue&type=script&lang=js"
export * from "./ToggleSidebar.vue?vue&type=script&lang=js"
import style0 from "./ToggleSidebar.vue?vue&type=style&index=0&id=59080ec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59080ec0",
  null
  
)

export default component.exports